import React, {useContext } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import {saveFile } from 'src/utils/pdfUtil.tsx';

import { AuthenticationContext } from '../../../../../providers/AuthenticationProvider';
const useReportDownload = () => {
  const { authHeader } = useContext(AuthenticationContext);
  const currentDate = format(new Date(), 'MM/dd/yyyy hh:mm:ss a');
  const sendRequest = async (url, request) => {
    const printedDate = { printedDate: currentDate };
    const payload = { ...request, ...printedDate };
    const { clmLveNumber, employeeName } = payload;
    const reportName = `${clmLveNumber}-${employeeName}-Notes.pdf`;
    try {
      const response = await axios
        .post(url, payload, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: authHeader(),
          },
          responseType: 'blob',
        })
        .then(res => res);
      saveFile(response, reportName);
    } catch (error) {
      console.log(`Download report error ${error}`);
    }
  };
  return {
    sendRequest,
  };
};
export default useReportDownload;
